import {AlertItemModel} from './alert-item.model';
import {ListModel} from '../../shared/models/list.model';
import {Utilities} from '../../shared/utilities/utilities.model';

export class Alerts extends ListModel {

	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach(alert => this.items.push(new AlertItemModel(alert)));
		}
	}
}
